import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';
import { useRBAC } from '../contexts/RBACContext';
import { UserTypes, normalizeUserRole } from '../constants/userTypes';
import LoadingState from '../components/common/LoadingState';
import VendorsView from '../components/dashboard/purchase/VendorsView';

// /shop/admin/vendors: the same Vendor Management view as Vendors in the
// Purchase panel, on its own page.
export default function VendorManagement() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { hasPermission, isLoading: rbacLoading, permissions } = useRBAC();

  const normalizedRole = normalizeUserRole(user?.role);
  const isAdmin = normalizedRole === UserTypes.ADMIN;

  const permissionsLoaded = Object.keys(permissions || {}).length > 0;
  const canManageShop = !rbacLoading && permissionsLoaded && hasPermission('Shop Management', 'Manage');

  // SECURITY CHECK: Admin-only and requires Shop Management: Manage
  useEffect(() => {
    if (rbacLoading) return;
    if (!permissionsLoaded) return;

    if (!canManageShop || !isAdmin) {
      navigate('/access-denied', { replace: true });
    }
  }, [canManageShop, isAdmin, navigate, permissionsLoaded, rbacLoading]);

  if (rbacLoading) {
    return <LoadingState message="Loading permissions..." fullScreen />;
  }

  if (!canManageShop || !isAdmin) {
    return null;
  }

  return (
    <div className="vv-page">
      <VendorsView />
    </div>
  );
}
